<template>
  <fieldset class="form-fieldset">

    <c-title
      v-if="legend || $slots.title"
      tag="legend"
    >

      {{ legend }}

      <span
        v-if="detail"
        class="form-fieldset__detail"
      >
        {{ detail }}
      </span>

    </c-title>

    <slot />

  </fieldset>
</template>

<script>
import CTitle from '@/components/CTitle'

export default {
  name: 'CFormFieldset',

  components: {
    CTitle
  },

  props: {
    detail: {
      type: String
    },
    legend: {
      type: String
    }
  }
}
</script>

<style scoped>
.form-fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}

.form-fieldset:has(> legend) {
  margin: 1em 0 0;

  > .title--level-2.title--legend {
    margin: 0 0 0.5em;
  }
}

.form-fieldset__detail {
  font-size: 0.9em;
  font-weight: 300;
  letter-spacing: normal;
  text-transform: none;
}

.form-fieldset__padded {
  margin: 3em 0 0 0;
}
</style>
